module.exports = __webpack_public_path__ + "img/profile-picture.1f436c37.jpg";